<template>
  <div class="quality-table">
    <table border="1">
      <tr>
        <th>序号</th>
        <th>检验项目</th>
        <th>标准</th>
        <th>检验情况</th>
        <th>是否合格</th>
      </tr>
      <!-- 包装 -->

      <template v-for="(item, index) in qualityList" :key="index">
        <template v-for="(subItem, subIndex) in item.list" :key="subIndex">
          <template v-if="item.type !== '备注'">
            <tr v-if="subIndex === 0">
              <td :rowspan="item.list.length" class="serial-number">
                {{ index + 1 }}
              </td>
              <td :rowspan="item.list.length" class="quality-type">
                {{ item.type }}
              </td>
              <td class="quality-title">{{ subItem.title }}</td>
              <td class="describe">
                <a-textarea
                  auto-size
                  v-model:value="subItem.describe"
                  :disabled="props.disabled"
                ></a-textarea>
              </td>
              <td>
                <a-radio-group
                  name="radioGroup"
                  v-model:value="subItem.qualified"
                  :disabled="props.disabled"
                >
                  <a-radio :value="true">是</a-radio>
                  <a-radio :value="false">否</a-radio>
                </a-radio-group>
              </td>
            </tr>

            <tr v-else>
              <td class="quality-title">{{ subItem.title }}</td>
              <td class="describe">
                <a-textarea
                  auto-size
                  v-model:value="subItem.describe"
                  :disabled="props.disabled"
                ></a-textarea>
              </td>
              <td>
                <a-radio-group
                  name="radioGroup"
                  v-model:value="subItem.qualified"
                  :disabled="props.disabled"
                >
                  <a-radio :value="true">是</a-radio>
                  <a-radio :value="false">否</a-radio>
                </a-radio-group>
              </td>
            </tr>
          </template>

          <template v-else-if="item.type === '备注'">
            <tr>
              <td class="serial-number">{{ index + 1 }}</td>
              <td class="quality-type">{{ item.type }}</td>
              <td colspan="3">
                <upload-annex-vue
                  :attachment="subItem.describe"
                  ref="uploadAnnex"
                  title="上传Log"
                ></upload-annex-vue>
              </td>
            </tr>
          </template>
        </template>
      </template>
    </table>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, watch } from "vue";
import { saveOrUpdateInspectionReport } from "@/request/view/repair";
import { getQualityList } from "../serve/qualityInspection";
import { Toast } from "@/utils";
import { message, notification } from "ant-design-vue";
import uploadAnnexVue from "./uploadAnnex.vue";

export default defineComponent({
  props: {
    echoList: Array,
    disabled: Boolean,
  },
  components: { uploadAnnexVue },
  setup(props, content) {
    const qualityList = reactive(getQualityList());

    const uploadAnnex = ref();

    const validateList = () => {
      qualityList.forEach((item) => {
        if (item.type === "其他") {
          return;
        }
        item.list.forEach((subItem) => {
          if (subItem.qualified === null) {
            Toast("warning", `请检验${subItem.title}项是否合格`, 3);
            throw new Error("");
          }
        });
      });
    };

    const getcontent = (list) => {
      const contentlist = [];
      list.forEach((item) => {
        contentlist.push({
          id: item.id,
          describe: item.describe,
          qualified: item.qualified,
        });
      });
      return JSON.stringify(contentlist);
    };

    const getReqData = (processId) => {
      return new Promise((resolve, reject) => {
        const list = [];
        qualityList.forEach((item) => {
          list.push({
            id: item.id,
            customerIssuesId: processId,
            inspectionItems: item.type,
            orderNumber: item.serialNum,
            content: getcontent(item.list),
          });
        });

        saveOrUpdateInspectionReport(list)
          .then((res) => {
            let type = res.code === 200 ? "success" : "warning";
            Toast(type, res.message, 3);
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    };

    const saveQuality = (processId) => {
      return new Promise(async (resolve, reject) => {
        try {
          await uploadAnnex.value[0].uploadFile().then((res) => {
            const urlFile = JSON.stringify(res);
            qualityList[6].list[0].describe = urlFile;
          });
          validateList();
          if (!processId) {
            reject("no processId");
          }
          getReqData(processId)
            .then(() => {
              resolve();
            })
            .catch((err) => {
              reject(err);
            });
        } catch (error) {
          reject(error);
        }
      });
    };

    const setQualityItemList = (qualityItemList, echoList) => {
      qualityItemList.forEach((item) => {
        const findItem = echoList.find((find) => find.id == item.id);
        if (findItem) {
          item.describe = findItem.describe;
          item.qualified = findItem.qualified;
        }
      });
    };

    const setListData = (list) => {
      qualityList.forEach((item, index) => {
        const findItem = list.find(
          (find) => find.orderNumber == item.serialNum
        );
        if (findItem === undefined) return;
        item.id = findItem.id;
        item.customerIssuesId = findItem.customerIssuesId;

        setQualityItemList(item.list, JSON.parse(findItem.content));

        if (props.disabled) {
          item.list = item.list.filter(
            (filterItem) => filterItem.qualified === false
          );
        }
      });
    };

    watch(
      () => props.echoList,
      (val) => {
        qualityList.length = 0;
        qualityList.push(...getQualityList());
        if (val && val.length > 0) {
          setListData(val);
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      props,
      qualityList,
      saveQuality,
      uploadAnnex,
    };
  },
});
</script>

<style lang="less" scoped>
.quality-table {
  font-size: 16px;
  margin-bottom: 16px;
  th {
    text-align: center;
  }
  th,
  tr {
    padding: 5px 10px;
  }
  td {
    padding: 5px;
  }
  .quality-type {
    text-align: center;
  }
  .serial-number {
    text-align: center;
  }
  .quality-title {
    width: 450px;
  }
  .describe {
    width: 320px;
  }
  ::v-deep .ant-radio-disabled .ant-radio-inner::after {
    background-color: #35b7ad !important;
  }
  ::v-deep .ant-radio-disabled + span {
    color: #000;
  }
  ::v-deep .ant-input-number-disabled {
    color: #000;
  }
}
</style>
